<template>
  <div
    ref="LoginNav"
    class="login-nav-wrapper"
    :class="[{'login-nav--rtl' : isRTL()}]"
    @keydown.esc="closeLoginNav"
  >
    <NavButton
      :is-connected="isConnected"
      :is-open="isOpen"
      :is-loading="isLoading"
      :aria-label-nav-button="dfltAriaLabelNavButton"
      :nav-button-label="dfltnavButtonLabel"
      :dfltclose-a11y="dfltcloseA11y"
      @toggleLoginNav="toggleLoginNav"
    />
    <Menu
      v-if="isOpen && computeItemList"
      :is-connected="isConnected"
      :is-member="isMember"
      :is-open="isOpen"
      :item-list="computeItemList"
      :status-info="statusInfo"
      :tracking-en-label="trackingEnLabel"
      :lang="lang"
      :action-callbacks="actionCallbacks"
      :close-a11y-label="dfltcloseA11y"
      @clickOnItem="clickOnItem"
      @loginNavClose="toggleLoginNav"
      @navBtnFocus="navBtnFocus"
    />
  </div>
</template>

<script src="./LoginNav.es"></script>
<style lang="scss" src="./LoginNav.scss" scoped></style>
